import { AsyncStatus, defaultInitialState, State } from 'hooks/useAsync';
import ChartMogulService, {
  ChartMogulVerifyIntegrationResult,
} from './ChartMogulService';
import { useCallback, useState } from 'react';

const useVerifyChartMogulIntegration = () => {
  const [{ error, isLoading, data, status }, setState] =
    useState<State<ChartMogulVerifyIntegrationResult>>(defaultInitialState);

  const verifyChartMogulIntegration = useCallback(async () => {
    setState({
      error: null,
      status: AsyncStatus.pending,
      data: null,
      isLoading: true,
    });
    const resultPromise = ChartMogulService.verifyChartMogulIntegration();
    resultPromise.then(
      (result) => {
        setState({
          error: null,
          status: AsyncStatus.resolved,
          data: result,
          isLoading: false,
        });
      },
      (error) => {
        setState({
          error: error,
          status: AsyncStatus.rejected,
          data: null,
          isLoading: false,
        });
      },
    );
  }, [setState]);

  return {
    verifyChartMogulIntegration,
    error,
    isLoading,
    isError:
      status === AsyncStatus.rejected ||
      (data?.data ? !data?.data?.isSuccess : false),
    isSuccess:
      status === AsyncStatus.resolved &&
      data?.data.isSuccess &&
      !!data?.data?.data &&
      data?.data?.data?.owned,
    data,
  };
};

export default useVerifyChartMogulIntegration;
